import './styles/ClientRetrievalNameStyle.css';
import React, { useState } from 'react';
import {
  BaseInput,
  NavigationButton,
  Keyboard,
  TopNav,
  TopNavToastMessage,
  ToastType,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';

const NAME_VALID_LENGTH = 50;
const NAME_FEEDBACK_LENGTH = 'El nombre no puede exceder 50 caractéres';
const NAME_FEEDBACK_INCORRECT = 'Escribir nombre y apellido completos';

const ClientRetrievalName: React.FC = () => {
  let history = useHistory();
  const [variableInError, setVariableInError] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const customerName = useTypedSelector(({ locker }) => {
    return locker.customerName;
  });
  const currentLockerPosition = useTypedSelector(({ locker }) => {
    return locker.currentLockerPosition;
  });
  const { updateCustomerName } = useActions();
  const validateName = () => {
    let names = customerName.split(' ');
    if (names.length < 2 || names.some((name) => name.length < 2)) {
      setFeedbackMessage(NAME_FEEDBACK_INCORRECT);
      return;
    }
    history.replace(`/${navigationPages.CLIENT_RETRIEVAL_SIGNATURE}`);
  };
  const handleKeypress = (e: any) => {
    //it triggers by pressing the enter key
    if (e.key === 'Enter') {
      validateName();
    }
  };
  const handleKeyboard = (option: string) => {
    setFeedbackMessage('');
    //it triggers by pressing the enter key
    if (option === 'go') {
      validateName();
      return;
    }
    if (option === 'back') {
      updateCustomerName(customerName.slice(0, -1));
      return;
    }
    if (customerName.length < NAME_VALID_LENGTH) {
      updateCustomerName(customerName + option.toLocaleUpperCase());
    } else {
      setFeedbackMessage(NAME_FEEDBACK_LENGTH);
    }
  };
  const renderContent = () => {
    return (
      <div className="client-name-container">
        <div className="client-name-tag-container">
          <p className="client-name-tag-instructions">
            {languageMap.client_retrieval_name.instructions[language]}
          </p>
          <BaseInput
            val={customerName}
            inputLabel=""
            inputPlaceholder="Nombre Completo"
            inError={variableInError === 'customerName'}
            onTextChange={(newVal: string) => {
              setVariableInError('');
              setFeedbackMessage('');
              updateCustomerName(newVal);
            }}
            handleKeypress={handleKeypress}
            extraClassContainer="no-padding-right full-width stretched"
            extraClass="placeholder-left"
          />
        </div>
        <div className="client-name-keyboard-container">
          <Keyboard
            onClickButton={(option) => {
              handleKeyboard(option);
            }}
            capsKeyboard={true}
          />
        </div>
      </div>
    );
  };
  return (
    <div id="clientRetrievalName" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container vertical">
            <p className="header nopadding nomargin">
              {languageMap.client_retrieval_name.title[language]}
            </p>
            <p className="subtitle nopadding">
              {languageMap.client_retrieval_name.subtitle[language]}{' '}
              {currentLockerPosition.packageCandidate?.awbNumber}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container"></div>
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.client_retrieval_name.confirm_button[language]
                }
                buttonClass="navigation-button confirm-button complete"
                onClickButton={() => {
                  validateName();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ClientRetrievalName };
